import React, { createContext, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import LoadingBar from 'react-top-loading-bar';
import usePortalContainer from '../../hooks/usePortalContainer';
import createPortalSSR from '../../helpers/createPortalSSR';

export const LoadingContext = createContext({});

// The app context provider component
const LoadingContextProvider = ({ children }) => {
    // defaultLoadingContext is returned by the server on the initial render
    const loadingBarRef = useRef(null);
    const startLoading = () => {
        if (!loadingBarRef.current) {
            return;
        }
        loadingBarRef.current.continuousStart();
    };
    const finishLoading = () => {
        if (!loadingBarRef.current) {
            return;
        }
        loadingBarRef.current.complete();
    };
    const contextValue = useMemo(() => ({
        startLoading,
        finishLoading,
    }), [startLoading, finishLoading]);

    const container = usePortalContainer('loading-bar');
    return (<LoadingContext.Provider
        value={contextValue}>
        {createPortalSSR(
            <LoadingBar
                color={'var(--action-color)'}
                ref={loadingBarRef}
                suppressHydrationWarning={true}
            />,
            container,
        )}
        {children}
    </LoadingContext.Provider>);
};

LoadingContextProvider.propTypes = {
    children: PropTypes.node,
};

export default LoadingContextProvider;